import { render, staticRenderFns } from "./summary-full.vue?vue&type=template&id=bd895002&"
import script from "./summary-full.vue?vue&type=script&lang=js&"
export * from "./summary-full.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports